/**
 *
 * @param {object} queryObj ex: {page: 1, email: 'test@gmail.com'}
 * @returns {string}
 */
export default function getUrlSearch(queryObj) {
  const params = new URLSearchParams();
  Object.keys(queryObj).forEach(key => {
    const value = queryObj[key];
    if (Array.isArray(value)) {
      value.forEach(item => params.append(key, item));
    } else if (value) {
      params.set(key, value);
    }
  });
  return params.toString();
}
